module.exports = __webpack_public_path__ + "static/minsal-67306bfc66445a41575006bc74991d22.jpg";